// extracted by mini-css-extract-plugin
module.exports = {"core":"AppDrawer_core__2hmhG","appHolder":"AppDrawer_appHolder__gq-5-","loader":"AppDrawer_loader__3BslA","fadeInAnimation":"AppDrawer_fadeInAnimation__2Cky4"};